import PropTypes from 'prop-types'

import {atomTagDesigns} from '@s-ui/react-atom-tag'
import MoleculeButtonGroup, {
  moleculeButtonGroupDisplay,
  moleculeButtonGroupSpaced
} from '@s-ui/react-molecule-button-group'
import TagChip, {tagChipTypes} from '@adv-mt/mt-tag-chip'

import {LIST_CLASS_NAME} from '../../config.js'
import useFilterBasic from '../hooks/useFilterBasic.js'

const FilterBasicTagGroup = ({allSelectionsId, allSelectionsLabel, isMultiSelect, onChange, options, value}) => {
  const {hasAllOptionsChecked, hasAllSelectionsField, onSelectAll, onSelectItem} = useFilterBasic({
    allSelectionsId,
    allSelectionsLabel,
    isMultiSelect,
    onChange,
    options,
    value
  })

  return (
    <div className={LIST_CLASS_NAME}>
      <MoleculeButtonGroup
        fullWidth
        display={moleculeButtonGroupDisplay.FLEX}
        spaced={moleculeButtonGroupSpaced.MEDIUM}
      >
        {hasAllSelectionsField && (
          <TagChip
            design={hasAllOptionsChecked ? atomTagDesigns.SOLID : atomTagDesigns.OUTLINE}
            label={allSelectionsLabel}
            onClick={onSelectAll}
            pressed={hasAllOptionsChecked}
            type={tagChipTypes.FILTERS}
            value={allSelectionsId}
          />
        )}
        {options.map(({id, label}) => {
          const isFocused = value.includes(id)

          return (
            <TagChip
              design={isFocused ? atomTagDesigns.SOLID : atomTagDesigns.OUTLINE}
              key={id}
              label={label}
              onClick={() => (hasAllSelectionsField || !isFocused) && onSelectItem({id})}
              pressed={isFocused}
              type={tagChipTypes.FILTERS}
              value={id}
            />
          )
        })}
      </MoleculeButtonGroup>
    </div>
  )
}

FilterBasicTagGroup.displayName = 'FilterBasicTagGroup'
FilterBasicTagGroup.propTypes = {
  allSelectionsId: PropTypes.string,
  allSelectionsLabel: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.array
}

export default FilterBasicTagGroup
